import React from 'react';
import { useParams } from 'react-router-dom';
import { FiDownload, FiStar, FiGlobe, FiGithub, FiShield } from 'react-icons/fi';

function ExtensionDetail() {
  const { id } = useParams();

  // Mock data - replace with API call
  const extension = {
    name: "Dark Mode Pro",
    description: "Force dark mode on all websites with advanced customization options",
    rating: 4.9,
    downloads: 8200,
    version: "2.1.0",
    author: "johndoe",
    category: "Productivity"
  };

  return (
    <div className="min-h-screen bg-dark-900 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="flex items-start gap-6 mb-8">
              <div className="w-24 h-24 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center text-5xl shadow-lg shadow-primary/30">
                🌙
              </div>
              <div className="flex-1">
                <h1 className="text-4xl font-bold mb-2">{extension.name}</h1>
                <p className="text-gray-400 text-lg mb-4">{extension.description}</p>
                <div className="flex items-center gap-6 text-sm">
                  <div className="flex items-center gap-2">
                    <FiStar className="text-yellow-500" />
                    <span>{extension.rating}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FiDownload />
                    <span>{extension.downloads.toLocaleString()} downloads</span>
                  </div>
                  <div className="px-3 py-1 bg-primary/20 text-primary rounded-full">
                    {extension.category}
                  </div>
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="bg-dark-800 rounded-2xl p-8 border border-gray-800 mb-8">
              <h2 className="text-2xl font-bold mb-4">About this extension</h2>
              <p className="text-gray-400 leading-relaxed">
                Dark Mode Pro is a powerful extension that automatically applies dark mode to all websites...
              </p>
            </div>

            {/* Reviews */}
            <div className="bg-dark-800 rounded-2xl p-8 border border-gray-800">
              <h2 className="text-2xl font-bold mb-6">Reviews</h2>
              <div className="space-y-6">
                <Review
                  user="alice"
                  rating={5}
                  comment="Best dark mode extension ever! Works flawlessly."
                  date="2 days ago"
                />
                <Review
                  user="bob"
                  rating={4}
                  comment="Great extension, but would love more customization options."
                  date="1 week ago"
                />
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div>
            <div className="bg-dark-800 rounded-2xl p-6 border border-gray-800 sticky top-24">
              <button className="w-full py-3 bg-primary rounded-lg font-medium mb-4 hover:bg-opacity-80 transition-all flex items-center justify-center gap-2">
                <FiDownload />
                Install Extension
              </button>

              <div className="space-y-4 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-400">Version</span>
                  <span className="font-medium">{extension.version}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Last updated</span>
                  <span className="font-medium">2 days ago</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Size</span>
                  <span className="font-medium">245 KB</span>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-700">
                <h3 className="font-semibold mb-3">Developer</h3>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full"></div>
                  <span>{extension.author}</span>
                </div>
                <div className="flex gap-2">
                  <button className="p-2 bg-dark-700 rounded-lg hover:bg-dark-600 transition-all">
                    <FiGlobe />
                  </button>
                  <button className="p-2 bg-dark-700 rounded-lg hover:bg-dark-600 transition-all">
                    <FiGithub />
                  </button>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-700">
                <div className="flex items-center gap-2 text-green-500 text-sm">
                  <FiShield />
                  <span>Verified & Secure</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Review({ user, rating, comment, date }) {
  return (
    <div className="pb-6 border-b border-gray-700 last:border-0">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gradient-to-br from-primary to-secondary rounded-full"></div>
          <span className="font-medium">{user}</span>
        </div>
        <div className="flex items-center gap-1">
          {[...Array(rating)].map((_, i) => (
            <FiStar key={i} className="text-yellow-500 fill-current" />
          ))}
        </div>
      </div>
      <p className="text-gray-400 mb-2">{comment}</p>
      <span className="text-sm text-gray-500">{date}</span>
    </div>
  );
}

export default ExtensionDetail;
